export default {
  'order-list': state => state['order-list'],
}
